export function isProfileInvitationPath(path: string): boolean {
    // Match both invitation routes, including Vue Router's case and trailing-slash variants.
    return /^\/(?:invite|i)\/?$/i.test(path)
}
